import {
  OPERATION,
  MOBILE_LINE_ACTIONS,
  SIM_TYPES,
  SHIPPING_TYPES,
} from '@/constants/operation';
import { LINE_TYPE } from '@/constants/constant';
import {
  CLIENT_ORION_TEXTS_IDS,
  ORION_TEXTS_IDS,
} from '@/constants/pages/mobileLines';
import { findText } from '..';

/*   YA CLIENTE   */
export const getDeliveryText = (texts) => {
  return (
    texts?.find(
      (text) => text.id === CLIENT_ORION_TEXTS_IDS.SHOP_SHIPMENT_DELIVERY
    )?.description || null
  );
};
export const clientCalculateShippingText = ({
  orionTexts,
  operationFormData,
  shippingTypes,
}) => {
  let shippingText = {};
  const isMobileMigrationChosen = operationFormData.some(
    (item) =>
      item.type === LINE_TYPE.MOBILE_LINE &&
      item[OPERATION.ACTION_CHOICER.ID]?.value === MOBILE_LINE_ACTIONS.MIGRATION
  );
  const isMobilePortabilityChosen = operationFormData.some(
    (item) =>
      item.type === LINE_TYPE.MOBILE_LINE &&
      item[OPERATION.ACTION_CHOICER.ID]?.value ===
      MOBILE_LINE_ACTIONS.PORTABILITY
  );
  const cardsChosen = [
    ...new Set(
      operationFormData
        .map((item) => {
          if (
            item[OPERATION.ACTION_CHOICER.ID]?.value ===
            MOBILE_LINE_ACTIONS.MIGRATION
          ) {
            return null;
          }
          return item[OPERATION.CARD_CHOICER.ID]?.value;
        })
        .filter((item) => item !== null)
    ),
  ];
  if (isMobileMigrationChosen) {
    shippingText = {
      nextStep: {
        ...findText({
          texts: orionTexts,
          textId: CLIENT_ORION_TEXTS_IDS.MIGRATION,
        }),
      },
    };
  }
  if (cardsChosen.length === 1) {
    const [cardChosen] = cardsChosen;
    const [shippingType] = shippingTypes[cardChosen] || [];

    if (cardChosen === SIM_TYPES.ESIM) {
      shippingText = {
        shippingType,
        ...shippingText,
        ...findText({
          texts: orionTexts,
          textId: CLIENT_ORION_TEXTS_IDS.DIGITAL_DELIVERY,
        }),
      };
    } else if (cardChosen === SIM_TYPES.SIM) {
      if (shippingType !== 'DELIVERY') {
        shippingText = {
          shippingType,
          ...shippingText,
          ...findText({
            texts: orionTexts,
            textId: CLIENT_ORION_TEXTS_IDS.SHOP,
          }),
        };
      } else {
        shippingText = {
          shippingType,
          ...shippingText,
        };
      }
    }
  } else if (cardsChosen.length > 1) {
    const [shippingSIM] = shippingTypes[SIM_TYPES.SIM]
    if (shippingSIM === 'DELIVERY') {
      shippingText = {
        shippingType: shippingSIM,
        ...shippingText,
        ...findText({
          texts: orionTexts,
          textId: CLIENT_ORION_TEXTS_IDS.DIGITAL_DELIVERY,
        }),
      };
    } else {
      shippingText = {
        ...shippingText,
        ...findText({
          texts: orionTexts,
          textId: CLIENT_ORION_TEXTS_IDS.SHOP_DIGITAL_DELIVERY,
        }),
      };
    }
  }
  if (isMobilePortabilityChosen) {
    const portabilityText = {
      ...shippingText,
      ...findText({
        texts: orionTexts,
        textId: CLIENT_ORION_TEXTS_IDS.PORTABILITY,
      }),
    };
    const { description: portabilityDesc } = { ...portabilityText };
    shippingText.description = `${shippingText?.description ? `${shippingText?.description} </br>` : ''
      }${portabilityDesc}`;
  }
  // if (shippingText?.shippingType === SHIPPING_TYPES.DELIVERY) {
  //   shippingText.title = '';
  //   shippingText.description = '';
  // }
  if (operationFormData.length === 1 && isMobileMigrationChosen) {
    shippingText.shippingType = null;
  }

  return shippingText;
};

/*   NO CLIENTE   */

export const calculateShippingText = ({ orionTexts, operationFormData }) => {
  const cardsChosen = [
    ...new Set(
      operationFormData
        .filter((item) => item.type === LINE_TYPE.MOBILE_LINE)
        .map((item) => item[OPERATION.CARD_CHOICER.ID]?.value)
    ),
  ];
  const isMobilePortabilityChosen = operationFormData.some(
    (item) =>
      item.type === LINE_TYPE.MOBILE_LINE &&
      item[OPERATION.ACTION_CHOICER.ID]?.value ===
      MOBILE_LINE_ACTIONS.PORTABILITY
  );
  let shippingText = {};
  if (cardsChosen.length === 1) {
    const [cardChosen] = cardsChosen;
    if (cardChosen === SIM_TYPES.ESIM) {
      shippingText = {
        ...findText({
          texts: orionTexts,
          textId: ORION_TEXTS_IDS.DIGITAL_DELIVERY,
        }),
      };
    } else if (cardChosen === SIM_TYPES.SIM) {
      shippingText = {
        ...findText({
          texts: orionTexts,
          textId: ORION_TEXTS_IDS.SHOP,
        }),
      };
    }
  } else if (cardsChosen.length > 1) {
    shippingText = {
      ...findText({
        texts: orionTexts,
        textId: ORION_TEXTS_IDS.SHOP_DIGITAL_DELIVERY,
      }),
    };
  }
  if (isMobilePortabilityChosen) {
    const portabilityText = {
      ...findText({
        texts: orionTexts,
        textId: ORION_TEXTS_IDS.PORTABILITY,
      }),
    };
    const { description: portabilityDesc } = { ...portabilityText };
    shippingText.description = `${shippingText?.description ? `${shippingText?.description} </br>` : ''
      }${portabilityDesc}`;
  }
  return shippingText;
};
